/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

import TemplateModel from 'cio/models/template';

interface PushContentPreviewBodyArgs {
  isRefreshing: boolean;
  preview: any;
  template: TemplateModel;
}

export default class PushContentPreviewBody extends Component<PushContentPreviewBodyArgs> {
  get isJsonEditor() {
    return this.args.template?.editor === 'json';
  }
}
